import React, { useState } from 'react';
import { Typography, Button, Paper, Box } from '@mui/material';

const Lesson = ({ lesson, onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = () => {
    if (currentStep < lesson.steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete();
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 2 }}>
      <Typography variant="h5" gutterBottom>{lesson.title}</Typography>
      <Box sx={{ minHeight: '200px', marginBottom: 2 }}>
        <Typography>{lesson.steps[currentStep].content}</Typography>
      </Box>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleNextStep}
      >
        {currentStep < lesson.steps.length - 1 ? 'Siguiente' : 'Completar lección'}
      </Button>
    </Paper>
  );
};

export default Lesson;